<template>
  <!--begin::LevelsView-->
  <div class="row gy-5 g-xl-8">
    <LevelsIndex widget-classes="card-xxl-stretch mb-5 mb-xl-8"></LevelsIndex>
  </div>
  <!--end::LevelsView-->
</template>

<script lang="js">
import { defineComponent, onMounted } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import LevelsIndex from "@/components/settings/LevelsIndex.vue";

export default defineComponent({
  name: "LevelsView",
  components: {
    LevelsIndex
  },
  mounted() {
    setCurrentPageTitle("Levels");
  }
});
</script>
